import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=518ec681&scoped=true&"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js&"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js&"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=518ec681&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518ec681",
  null
  
)

export default component.exports